import { gql } from "@apollo/client";

const UPDATE_SPORTS = gql`
  mutation updateSport(
    $id: Int!
    $icon: Upload
    $title: String!
    $abbreviation: String
    $resourceTitle: String
    $enableDiscipline: Boolean
    $enableCourts: Boolean
    $enableStages: Boolean
    $displayDraws: Boolean
    $displayGroups: Boolean
    $displayLiveStandings: Boolean
    $displayOrderPlay: Boolean
    $displayListResults: Boolean
    $displayPendingResults: Boolean
    $displayTournamentResults: Boolean
    $isEnablePairingStandings: Boolean
    $isEnableRounds: Boolean
    $textBox: String
    $isDisplayAthleteChessTitle: Boolean
    $isDisplaySeeds: Boolean
    $isDisplaySegments: Boolean
    $footballLineupEnabled: Boolean
    $footballAdvancedMatchDetailsEnabled: Boolean
    $footballGroupStandingsEnabled: Boolean
    $footballLiveStandingsEnabled: Boolean
  ) {
    updateSport(
      updateSportInput: {
        id: $id
        title: $title
        icon: $icon
        abbreviation: $abbreviation
        resourceTitle: $resourceTitle
        enableDiscipline: $enableDiscipline
        enableCourts: $enableCourts
        enableStages: $enableStages
        displayDraws: $displayDraws
        displayGroups: $displayGroups
        displayLiveStandings: $displayLiveStandings
        displayOrderPlay: $displayOrderPlay
        displayListResults: $displayListResults
        displayPendingResults: $displayPendingResults
        displayTournamentResults: $displayTournamentResults
        isEnablePairingStandings: $isEnablePairingStandings
        isEnableRounds: $isEnableRounds
        textBox: $textBox
        isDisplayAthleteChessTitle: $isDisplayAthleteChessTitle
        isDisplaySeeds: $isDisplaySeeds
        isDisplaySegments: $isDisplaySegments
        footballLineupEnabled: $footballLineupEnabled
        footballAdvancedMatchDetailsEnabled: $footballAdvancedMatchDetailsEnabled
        footballGroupStandingsEnabled: $footballGroupStandingsEnabled
        footballLiveStandingsEnabled: $footballLiveStandingsEnabled
      }
    ) {
      id
      title
      icon
      abbreviation
      enableDiscipline
      enableCourts
      enableStages
      displayDraws
      displayGroups
      displayLiveStandings
      displayOrderPlay
      displayListResults
      displayPendingResults
      displayTournamentResults
      textBox
      resourceTitle
      footballLineupEnabled
      footballAdvancedMatchDetailsEnabled
      footballGroupStandingsEnabled
      footballLiveStandingsEnabled
    }
  }
`;

export default UPDATE_SPORTS;
